import { message } from "antd";
import { AxiosError } from "axios";
import Auth from "../../api/Auth";
import ErrorComponent from "../../ui-kit/ErrorComponent";

const mappingErrorFromObjectToString = (error: { [key: string]: string[] }) => {
  return Object.entries(error).map(
    ([key, arrayOfErrors]) => `${key}: ${arrayOfErrors?.map((error) => error)}`,
  );
};

type ErrorType = AxiosError | string;

const setError = (error: ErrorType): string[] | string => {
  if (typeof error === "string") {
    return error;
  }
  const {
    response: { status, data: { errors } = null },
  } = error;

  if (!errors) {
    if (status === 403) {
      return "Ошибка доступа";
    }
    return;
  }
  if (Array.isArray(errors)) {
    return errors;
  } else if (typeof error === "object" && !Array.isArray(error)) {
    return mappingErrorFromObjectToString(errors);
  } else {
    return "Ошибка";
  }
};

export const checkRedirect = (...error) => {
  console.log("error");
  if (error.some((x) => x?.response?.status === 401)) {
    const arrOfPaths = [
      "/login",
      "/reset-password",
      "/change-password",
      "/esia/choose-org",
    ];
    if (!arrOfPaths.includes(window.location.pathname)) {
      Auth.getUserInfo()
        .then(() => {
          console.log(...error);
          return true;
        })
        .catch(() => {
          window.location.href = `${window.location.origin}/login`;
          return false;
        });
    }
    return true;
  }
  return true;
};

export const handleError = (errorMsg) => {
  const error = setError(errorMsg);
  return message.error({
    content: ErrorComponent({ error }),
  });
};
